export default "__VITE_ASSET__Ws9VUcZL__"